import { getLocaleFromTimezone } from "~/helpers/getLocaleFromTimezone";
import { setI18n } from "ice.fo.utils/DateUtils";

export default function ({ app }) {
  // Initial locale setup
  const userLocale = getLocaleFromTimezone();

  console.log(`Setting initial locale to: ${userLocale}`);
  app.i18n.setLocale(userLocale);
  setI18n(app.i18n);

  // Watch for route changes
  app.router.beforeEach((to, from, next) => {
    const currentLocale = app.i18n.locale;
    const newLocale = getLocaleFromTimezone();

    // Update locale if changed
    if (currentLocale !== newLocale) {
      app.i18n.setLocale(newLocale);
    }

    next();
  });

  // Optional: Listen for locale changes
  app.i18n.onLanguageSwitched = (oldLocale, newLocale) => {
    console.log(`Language switched from ${oldLocale} to ${newLocale}`);
  };
}
